{
  "splash": {
    "title": "Desarrollado con el apoyo del Gobierno de Canadá"
  },
  "all-listings": {
    "disconnected": {
      "text": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Crea tu cuenta o inicia sesión para ver los recursos disponibles en ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "¡Comienza tu aventura aquí!",
        "primaryButtonText": "¡Publica una oferta!",
        "secondLine": "Participa en el catálogo ofreciendo objetos para prestar."
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les ressources disponibles dans ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "¿Te gusta lo que ves? Lleva ACCÈS REFRAIN en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación ACCÈS REFRAIN"
    }
  },
  "contact-information": {
    "prompt": "Agrega el código postal del festival para ver qué objetos están disponibles en los alrededores.",
    "title": "Tu dirección"
  },
  "contact-us": {
    "firstParagraph": "El servicio a los miembros de ACCÈS REFRAIN está disponible por correo electrónico y mensajería. Te responderemos lo más rápido posible.",
    "faqLink": "https://lerefrain.com/fr/faq-acces-refrain",
    "chatPrompt": {
      "bugReport": "¡Hola! 😊\n\nGracias por explicarnos qué está fallando.",
      "suggestion": "¡Hola! 😊\n\nSiempre estamos abiertos a sugerencias. Gracias por ayudarnos a mejorar nuestro servicio.\n\n¡Gracias!"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Se necesita un código de invitación para usar ACCÈS REFRAIN. Para obtener uno, visita <a>el espacio miembro Refrain</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/fr/connexion"
  },
  "guidelines": {
    "fifthParagraph": "No utilizar ACCÈS REFRAIN para vender objetos."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió a ACCÈS REFRAIN",
        "title": "Explorador"
      }
    }
  },
  "introModal": {
    "title": "Estimado/a {{name}},",
    "first": "Bienvenido/a a la aplicación de intercambio y descubre el <strong>amplio catálogo de recursos materiales disponibles.</strong>",
    "second": "<strong>Compartir es una muestra de confianza</strong>: ¡cuanto más prestes, más ganas tendrán los demás de prestarte!",
    "third": "<strong>Sabe que menos del 0,1 % de todos los intercambios</strong> generan un daño. Y no es por mala fe. Es simplemente normal cuando los objetos se usan un poco más."
  },
  "my-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "credentialInformationTitle": "Cuenta y seguridad",
    "personalInformationTitle": "Información del perfil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "firstNameFieldPlaceholder": "ej. Festival del Buen Viento de Ste-Pépitte",
    "title": "Información del perfil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Tu suscripción a ACCÈS REFRAIN es cortesía del Refrain."
      },
      "title": {
        "enterprise": "Suscripción ACCÈS REFRAIN"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "Suscripción ACCÈS REFRAIN"
    },
    "noEnd": "Esta suscripción es válida mientras seas miembro del Refrain."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ej: Consola de sonido",
      "descriptionFieldPlaceholder": {
        "offer": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto...",
        "request": "Marca, dimensiones, color, peso, estado, año de adquisición, condiciones de préstamo, especificidades del objeto..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenido/a al Club",
        "body": "¡Descubre ACCÈS REFRAIN!"
      }
    },
    "welcome": "¡Bienvenido/a a ACCÈS REFRAIN!",
    "welcomeMessage": "Gracias por confiar en nosotros.",
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de ACCÈS REFRAIN."
      }
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "¡Aumentaste tu impacto realizando 5 intercambios! Ahora accedes al nivel máximo: <strong>Super Compartidor</strong>, un ejemplo a seguir para los otros miembros de ACCÈS REFRAIN.\n\n¡Bravo! Con cada intercambio, haces crecer tu impacto para un futuro más verde."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "La necesidad fue cubierta en ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nombre del festival",
    "firstNameFieldPlaceholder": "ej. Festival del Buen Viento de Ste-Pépitte",
    "pictureFieldSubtitle": "Esta imagen se mostrará en tus anuncios y tu perfil.",
    "pictureFieldTitle": "Agregar una imagen del logo del festival",
    "title": "Información del perfil"
  },
  "privacy": {
    "link1": "https://lerefrain.com/fr/acces-refrain-conditions-dutilisation",
    "link2": "https://lerefrain.com/fr/acces-refrain-politique-de-confidentialite",
    "line3": "de ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "¡Acabas de contribuir a enriquecer el catálogo de <strong>ACCÈS REFRAIN</strong>!\n\nPuedes modificar tus ofertas en cualquier momento en tu centro de intercambios."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contactar a ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "Al ofrecer tus objetos, animas incluso a los festivales más tímidos a pedir."
      }
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain es la aplicación para <strong>compartir equipamiento</strong> entre festivales.",
      "footerText": "No te <strong>limites</strong> a lo que posee tu organización."
    },
    "accessMore": {
      "headerText": "En Accès Refrain, accedes a una <strong>abundancia de equipamiento</strong>.",
      "footerText": "Materiales, escenarios, etc.: aquí encuentras <strong>realmente de todo.</strong>"
    },
    "offerMore": {
      "headerText": "En Accès Refrain, <strong>compartir</strong> es <strong>ayudar</strong> a otros festivales mientras <strong>optimizas tus recursos</strong>.",
      "footerText": "Deja que otros festivales <strong>aprovechen</strong> tu equipamiento <strong>poco utilizado.</strong>"
    }
  }
}
